import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useProductTenderTextContext } from "../ProductTenderTextContext"

export const ProductTenderTextCopyToClipboard = React.memo(() => {
  const { t } = useTranslation()
  const { copyToClipboard, isLoading } = useProductTenderTextContext()

  return (
    <Button
      variant={ButtonVariant.SECONDARY}
      onClick={copyToClipboard}
      label={t("General.CopyToClipboard")}
      icon={IconName.DUPLICATE}
      className="btn--borderless btn--bleed"
      disabled={isLoading}
    />
  )
})

ProductTenderTextCopyToClipboard.displayName =
  "ProductTenderText.CopyToClipboard"
